import React, { ReactElement } from 'react';
import '../style.scss';
import './style.scss';
import { Caption } from 'views/mutual/caption';
import { Description, labelColor, labelSize } from 'views/mutual/description';
import { QuestionCard } from 'views/mutual/questionCard';
import { DealerQuestionBottom, DealerQuestionTop } from './module/dealerQuestion';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { IdentificationQuestionBottom, IdentificationQuestionTop } from './module/identificationQuestion';
import { MailAddressQuestionBottom, MailAddressQuestionTop } from './module/mailAddressQuestion';
import { SelfieQuestionBottom, SelfieQuestionTop } from './module/selfieQuestion';
import { CheckInput } from 'views/templates/module/checkInput';
import { useCorporateAccountAdvancedQuestion } from './hooks';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { TemplateProps } from '../common';

export type AdvanceQuestionProps = {
  formik: any;
  dealerQuestionProps: any;
  identificationQuestionProps: any;
  mailAddressQuestionProps: any;
  selfieQuestionProps: any;
  personalInformationProps: any;
  generalTermsConditionProps: any;
  confirmResponsibilityProps: any;
};

export const AdvanceQuestionWrapper = () => {
  return <AdvanceQuestion {...useCorporateAccountAdvancedQuestion({ isUpdate: false })} />;
};

export const AdvanceQuestion = ({
  formik,
  dealerQuestionProps,
  mailAddressQuestionProps,
  identificationQuestionProps,
  selfieQuestionProps,
  personalInformationProps,
  generalTermsConditionProps,
  confirmResponsibilityProps,
  isUpdate,
}: AdvanceQuestionProps & TemplateProps) => {
  const dealerQuestionTop: ReactElement = <DealerQuestionTop />;
  const dealerQuestionBottom: ReactElement = <DealerQuestionBottom {...dealerQuestionProps} />;

  const mailAddressQuestionTop: ReactElement = <MailAddressQuestionTop {...{ isUpdate }} />;
  const mailAddressQuestionBottom: ReactElement = <MailAddressQuestionBottom {...mailAddressQuestionProps}/>

  const identificationQuestionTop: ReactElement = <IdentificationQuestionTop {...{ isUpdate }} />;
  const identificationQuestionBottom: ReactElement = <IdentificationQuestionBottom {...identificationQuestionProps} />;

  const selfieQuestionTop: ReactElement = <SelfieQuestionTop {...{ isUpdate }} />;
  const selfieQuestionBottom: ReactElement = <SelfieQuestionBottom {...selfieQuestionProps} />;

  useCustomLocationName('口座開設');

  return (
    <form onSubmit={formik.handleSubmit} className="accountOpenTemplate">
      <div className="accountOpenTemplate_description">
        <Caption label={isUpdate ? '登録情報ご変更の事前質問' : '法人口座開設お申込の事前質問'} />
        {!isUpdate && (
          <>
            <Description
              label="お申し込みの前に、取引担当者様をお決めください。"
              labelColor={labelColor.red}
              labelSize={labelSize.medium}
            />
            <Description
              label="※ FPGオンライン取引サービスへのログインID・ログインパスワードは、取引担当者様に発行します。"
              labelColor={labelColor.gray}
              labelSize={labelSize.small}
            />
            <Description
              label="※ 各種お問い合わせは、取引担当者様からのみ承ります。"
              labelColor={labelColor.gray}
              labelSize={labelSize.small}
            />
            <Description
              label={
                <>
                  ※会社法上の法人（株式会社、合同会社等）および特例有限会社以外の法人のお客様は、オンラインではお取引できない場合がございます。その場合は対面での口座開設となりますが、オンライン取引の可否については、
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={process.env.REACT_APP_FPG_CONTACT_FORM_URL}
                    style={{ color: '#4f79e7' }}
                  >
                    お問い合わせフォーム
                  </a>
                  よりご確認をお願いいたします。
                </>
              }
              labelColor={labelColor.gray}
              labelSize={labelSize.small}
            />
          </>
        )}
      </div>
      {!isUpdate && (
        <>
        <QuestionCard
          topChildren={dealerQuestionTop}
          bottomChildren={dealerQuestionBottom}
          error={dealerQuestionProps.error}
        />
      
      <QuestionCard
        topChildren={mailAddressQuestionTop}
        bottomChildren={mailAddressQuestionBottom}
        error={mailAddressQuestionProps.error}
      />
      </>
      )}
      <QuestionCard
        topChildren={identificationQuestionTop}
        bottomChildren={identificationQuestionBottom}
        error={identificationQuestionProps.error}
      />
      <QuestionCard
        topChildren={selfieQuestionTop}
        bottomChildren={selfieQuestionBottom}
        error={selfieQuestionProps.error}
      />
      <div className="agreementDocument">
        <CheckInput
          name="agreement_privacy_protection"
          label={
            <>
              <a
                className="link"
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_PRIVACY_PROTECTION_URL}
              >
                「個人情報の保護に関する公表事項」
              </a>
              の内容を理解の上、同意します
            </>
          }
          {...personalInformationProps}
        />
        <CheckInput
          name="general_terms_condition"
          label={
            <>
              <a
                className="link"
                target="_blank"
                rel="noopener noreferrer"
                href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
              >
                「FPGオンライン取引・電子署名取引一般規約」
              </a>
              第12条第9項及び第10項の個人データの第三者提供について同意します
            </>
          }
          {...generalTermsConditionProps}
        />
        <CheckInput
          name="confirm_responsibility"
          label={
            <>
              口座開設後に行う取引は、お客様をFPGに紹介した紹介者様がいる場合であっても、お客様ご自身がその責任をもって行うことに同意します
            </>
          }
          {...confirmResponsibilityProps}
        />
      </div>
      <Button
        type={ButtonType.Submit}
        label={isUpdate ? '登録情報の変更' : '口座開設の手続きを進める'}
        buttonFill={ButtonFill.black}
        buttonSize={ButtonSize.medium}
        disable={
          !formik.values.personalInformation ||
          !formik.values.generalTermsCondition ||
          !formik.values.confirmResponsibility
        }
      />
    </form>
  );
};
